export function roundNumber(number: number): number {
  const [, fractionalPart] = number.toString().split('.')
  if (fractionalPart && fractionalPart.length > 6) {
    const roundedNumber = Math.floor(+number * 1e6) / 1e6 === 0.0 ? 0 : Math.floor(+number * 1e6) / 1e6
    return roundedNumber
  }
  return number
}

export function roundNumberWithoutZeroFormatting(number: number): number | string {
  const [, fractionalPart] = number.toString().split('.')
  if (fractionalPart && fractionalPart.length > 6) {
    const roundedNumber = Math.floor(+number * 1e6) / 1e6 === 0.0 ? '0.000000' : Math.floor(+number * 1e6) / 1e6
    return roundedNumber
  }
  return number
}

export function roundNumberWithPrecision(number: number, precision: number): number {
  const [, fractionalPart] = number.toString().split('.')

  if (fractionalPart && fractionalPart.length > precision) {
    const multiplier = Math.pow(10, precision)
    const roundedNumber = Math.floor(number * multiplier) / multiplier
    return roundedNumber
  }

  return number
}
